import React from "react";
import { Button, Modal } from "react-bootstrap";
import Tick from "../assets/images/tick.jpg";
// Bootstrap CDN
// import "bootstrap/dist/css/bootstrap.min.css";

const ConfirmModal = (props) => {
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-success'>{props.Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.message}
          <img src={Tick} alt='tick' style={{width: "15px"}}/>
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <Button variant='secondary' onClick={props.handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ConfirmModal;
